const topicsData = [
  { name: '极限追凶', count: '128万讨论', hot: true },
  { name: '暑期档', count: '96万讨论', hot: true },
  { name: '科幻巨制', count: '87万讨论', hot: false },
  { name: '喜剧片推荐', count: '74万讨论', hot: true },
  { name: '悬疑烧脑', count: '65万讨论', hot: false },
  { name: '动作大片', count: '58万讨论', hot: false },
  { name: '国产佳片', count: '52万讨论', hot: true },
  { name: '4K观影', count: '43万讨论', hot: false },
  { name: '经典回顾', count: '38万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-hashtag text-2xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
            话题热榜
          </h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10 ml-11">
          悟空影视社区当前最热门的话题讨论
        </p>

        <div className="flex flex-wrap gap-3">
          {topicsData.map((topic, idx) => (
            <div
              key={idx}
              className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/60 hover:border-primary-500/30 transition-all duration-200 cursor-pointer group"
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 flex-shrink-0"></span>
              )}
              <span className="text-sm text-foreground-300 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-[11px] text-foreground-600 whitespace-nowrap">
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}